import { render } from "./OtherSetting.vue?vue&type=template&id=db826aa4&scoped=true"
import script from "./OtherSetting.vue?vue&type=script&lang=js"
export * from "./OtherSetting.vue?vue&type=script&lang=js"

import "./OtherSetting.vue?vue&type=style&index=0&id=db826aa4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db826aa4"]])

export default __exports__